import React, {useRef, useState} from 'react';
import {v4 as uuidv4} from 'uuid';
import {submitPhotographerNote} from '../../util/project_api_util';

export default function PhotographerTeamNotes({project}) {
  const [body, setBody] = useState('');
  const [history, setHistory] = useState(project.photographer_notes || '');
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const key = useRef(uuidv4());
  const busy = useRef(false);
  async function submit(event) {
    event.preventDefault();
    if (busy.current || !body.trim()) return;
    busy.current = true; setSending(true); setError(''); setMessage('');
    try {
      const result = await submitPhotographerNote(project.id, body.trim(), key.current);
      setHistory(result.photographer_notes); setBody(''); key.current = uuidv4();
      setMessage('Sent to team. Your note has been saved.');
    } catch (failure) {
      setError(failure.responseJSON?.errors?.join(' ') || 'Your note could not be confirmed. Please try again.');
    } finally { busy.current = false; setSending(false); }
  }
  return <section className="photographerTeamNotes" aria-labelledby="photographer-team-notes-title">
    <h2 id="photographer-team-notes-title">Notes for our team</h2>
    <p>Share shoot details or editing instructions. These notes are internal and notify our team.</p>
    <form onSubmit={submit}>
      <label htmlFor="photographer-team-note">New note</label>
      <textarea id="photographer-team-note" value={body} maxLength={5000} required disabled={sending}
        onChange={event => {setBody(event.target.value); key.current = uuidv4(); setMessage('');}}
        placeholder="Anything our team should know about this shoot?" />
      <div className="photographerNoteSubmit">
        <span role="status">{message}</span>
        <button className="projectDetailAction" type="submit" disabled={sending || !body.trim()}>
          {sending ? 'Sending…' : 'Send Note to Team'}
        </button>
      </div>
      {error && <p role="alert" className="photographerNoteError">{error}</p>}
    </form>
    {history && <details className="photographerNoteHistory"><summary>Previous notes</summary><div>{history}</div></details>}
  </section>;
}
